// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedPasswordType {
  staff: {"enum_constant":"staff","rule":"required: upper; required: lower; required: digit, special; allowed: unicode; minlength: 12;"};
  user: {"enum_constant":"user","rule":"minlength: 6;"};
}

export type PasswordTypeId = keyof IParsedPasswordType;
export type PasswordTypeData = IParsedPasswordType[PasswordTypeId];
const data: PasswordTypeData[] = [{"enum_constant":"staff","rule":"required: upper; required: lower; required: digit, special; allowed: unicode; minlength: 12;"},{"enum_constant":"user","rule":"minlength: 6;"}];
export default data;
